import $ from "jquery";
import Tutorial from "../tutorials/tutorial";

export default class UnlockCalculationsTutorialFunctions extends Tutorial {

  exitTutorial = () => {
    if (this.overlayElement) {
      $(this.overlayElement).fadeOut(300, () => {
        this.props.setShowUnlockCalculationsTutorial(false);
        this.props.setUnlockCalculationsTutorialFinished(true);
      })
    }
  };

}
